import {Component, Input, OnInit} from '@angular/core';
import {
    NetscopeCommonFlowviewComponent
} from "@app/netscope/netscope-common-flowview/netscope-common-flowview.component";
import {VisualisationDataForRenderers} from "@app/netscope/netscope-common-flowview/renderers/ClustersViewerRenderer";
import {NetscopeUtils} from "@app/netscope/netscope-utils";

class VolumetryColor {
    color: string;
    volumetryLabel: string;
}

@Component({
  standalone: false,
  selector: 'netscope-common-flowview-legend',
  templateUrl: './netscope-common-flowview-legend.component.html',
  styleUrl: './netscope-common-flowview-legend.component.css'
})
export class NetscopeCommonFlowviewLegendComponent implements OnInit {

    selectedView = "";
    gradient: Array<VolumetryColor> = [];
    display: boolean = true;

    ngOnInit() {
    }

    hideLegend = () => {
        this.display = false;
    }

    updateLegend = (selectedView: string, visualisationData: VisualisationDataForRenderers) => {
        this.selectedView = selectedView;
        this.display = true;

        if (visualisationData == undefined) {
            return true;
        }

        this.gradient = [];

        let safeLogMinBytes = NetscopeUtils.safeLog(visualisationData.minBytes);
        let safeLogMaxBytes = NetscopeUtils.safeLog(visualisationData.maxBytes);

        let howManyLegendItems = 5;
        let incrementSize = (safeLogMaxBytes - safeLogMinBytes) / howManyLegendItems;

        for (let i=0; i < howManyLegendItems + 1; i++) {
            let volumetryLog10 = safeLogMinBytes + i * incrementSize;
            let volumetry = Math.pow(10, volumetryLog10);

            if (volumetry < 1000) {
                volumetry = Math.round(volumetry);
            }

            let gradientItem = new VolumetryColor();
            gradientItem.volumetryLabel = NetscopeUtils.formatBytes(volumetry)
            gradientItem.color = NetscopeUtils.exchangedBytesToColorHex(volumetry, visualisationData.minBytes, visualisationData.maxBytes);

            this.gradient.push(gradientItem);
        }

        return true;
    }

}
